import { Upload, message, UploadProps } from 'antd';
import { CloudUploadOutlined } from '@ant-design/icons';
import { Flex } from '@/components';
import { useTranslation } from 'react-i18next';

const { Dragger } = Upload;

export interface UploadFileProps extends UploadProps {
  iconProps?: any;
  text?: React.ReactNode;
  hints?: React.ReactNode[] | string[];
}

const UploadFile: React.FC<UploadFileProps> = ({
  onChange,
  iconProps,
  text = undefined,
  hints = undefined,
  ...rest
}) => {

  const [t] = useTranslation(['common']);

  if (!text) {
    text = t('common:messages.drag-file-here');
  }

  if (!hints) {
    hints = [
      t('common:messages.max-upload', { maxSize: '2MB' }),
      t('common:messages.allowed-files', { exts: 'jpg , png , pdf' })
    ];
  }


  const props = {
    name: 'file',
    beforeUpload(file: any) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isLt2M) {
        onChange(file);
      }
      else {
        message.error('حجم فایل باید کمتر از 2 مگابایت باشد.');
      }
      return false;
    },
    onDrop(e: any) {
      console.log('Dropped files', e.dataTransfer.files);
    },
    accept: '.pdf,.jpg,.png',
  };
  return (
    <Dragger {...props} {...rest}>
      <Flex gap={4} direction="column">
        <p className="ant-upload-drag-icon">
          <CloudUploadOutlined {...iconProps} />
        </p>
        <p className="ant-upload-text">{text}</p>
        {hints.map((hint, i) =>
          <p key={i} className="ant-upload-hint">{hint}</p>
        )}
      </Flex>
    </Dragger>
  );
};

export default UploadFile;
